/**Dependencies */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

/**Componentes */
import {
  Row,
  Col,
  ButtonGroup,
  Button,
  Card,
  Accordion,
  Form,
  Modal,
} from "react-bootstrap";
import { CardResultHotel } from "../components/CardResultHotel";
import Slider from "react-slick";
import { settings, settingsInfoHotel } from "../utils";
import { CardCarrousel } from "../components/CardCarrousel";
import { SectionAdvise } from "../components/SectionAdvise";

/**Images */
import bannerLuckyDay from "../images2/banner-lucky-day.png";
import xcaret from "../images2/hotels/Parque Xcaret.png";
import xenses from "../images2/hotels/Parque Xenses.png";
import fiestaAmericana from "../images2/hotels/Grand Fiesta Americana.png";
import moonPalace from "../images2/hotels/Moon Palace.png";
import desayuno from "../images2/icons/Desayuno.png";
import beach from "../images2/icons/Playa.png";
import wifi from "../images2/icons/Wifi.png";
import { FaStar } from "react-icons/fa";
import imgPreview from "../images/preview.jpg";
import { IoIosArrowDown } from "react-icons/io";
import hiltonCancun from "../images2/Hilton Cancun Mar Caribe.png";
import { getActivePDP } from "../services/checkoutService";
import {
  getActividades,
  getActividadesFilters,
} from "../services/searchService";
import { Currency, fetchMarkup, totalPrices } from "../helpers";
import { SearchEngine } from "../components/SearchEngine";
import { Loader } from "../components/Loader";
import { comisionUser } from "../services/LoginService";
import Skeleton from "react-loading-skeleton";
export const ExperienciasResultado = () => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  const [ResultHotel] = useState([
    {
      id: 1,
      imgHotel: xcaret,
      rank: "5.0",
      name: "Parque Xcaret",
      zone: "Cancún, Mexico",
      imgAmenitie: [
        {
          img: desayuno,
          text: "Desayuno",
        },
        {
          img: beach,
          text: "Playa",
        },
        {
          img: wifi,
          text: "Wifi",
        },
      ],
      pricePeerNight: "000.00",
      totalPrice: "0,000.00",
    },
    {
      id: 2,
      imgHotel: xenses,
      rank: "5.0",
      name: "Parque Xenses",
      zone: "Cancún, Mexico",
      imgAmenitie: [
        {
          img: desayuno,
          text: "Desayuno",
        },
        {
          img: beach,
          text: "Playa",
        },
        {
          img: wifi,
          text: "Wifi",
        },
      ],
      pricePeerNight: "000.00",
      totalPrice: "0,000.00",
    },
  ]);
  const [destinies] = useState([
    {
      hotel: "Seadust Cancún Family Resort",
      location: "Cancún, México.",
      price: "$3,937",
      days: "10",
      img: moonPalace,
      stars: "5.0",
    },
    {
      hotel: "Hilton Cancun Mar Caribe All-Inclusive Resort",
      location: "Cancún, México",
      price: "$4,466",
      days: "10",
      img: hiltonCancun,
      stars: "4.5",
    },
    {
      hotel: "Moon Palace Cancún",
      location: "Cancún, México",
      price: "$8,061",
      days: "10",
      img: fiestaAmericana,
      stars: "4.3",
    },
  ]);
  const [filteredData, setFilteredData] = useState(ResultHotel);
  const [acts, setActs] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [visibleCount, setVisibleCount] = useState(10); // Contador de resultados visibles
  const [filters, setFilters] = useState([]);
  const [persons, setPersons] = useState([]);
  const [pdp, setPdp] = useState();
  const [totalNights, setTotalNights] = useState(0);
  const [totalPersons, setTotalPersons] = useState([]);
  const [nameDestination, setNameDestination] = useState("");
  const [selectedValues, setSelectedValues] = useState({});
  const [filteredActs, setFilteredActs] = useState([]);
  const [markup, setMarkup] = useState("");
  const [paramsUrl, setParamsUrl] = useState({});
  const [totalPax, setTotalPax] = useState(0);
  const [randomActivities, setRandomActivities] = useState([]);
  const [show, setShow] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const location = useLocation();
  let requestData = [];
  const ahora = new Date();
  // Función para parsear los parámetros de la URL
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location?.search); // Extraemos los parámetros de la URL

  const construirRequest = () => {
    const checkin = queryParams?.in; // Fecha de check-in
    const checkout = queryParams?.out; // Fecha de check-out
    const id = queryParams?.id; // ID del destino
    const tipo = queryParams?.t || "destination"; // Tipo de alojamiento
    setSelectedDates([checkin, checkout]);
    // Crear habitaciones a partir de los parámetros pax
    const personas = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [adultos, edadesAdults, menores, edades] =
          queryParams[key]?.split("|");
        return {
          num_adultos: parseInt(adultos, 10),
          num_menores: parseInt(menores, 10),
          edad_adultos: edadesAdults ? edadesAdults?.replace(/,/g, "|") : "", // Convertimos comas en pipes
          edad_menores: edades ? edades?.replace(/,/g, "|") : "", // Convertimos comas en pipes
        };
      });

    const totalPersonas = personas?.reduce(
      (total, persona) => total + persona?.num_adultos + persona?.num_menores,
      0
    );

    const PersonasFormatted = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [adultos, edadesAdults, menores, edades] =
          queryParams[key]?.split("|");

        // Convertir edades (si las hay) en un array
        const edadesArray =
          edades === "0" || !edades ? [] : edades?.split(",")?.map(Number);

        const edadesAdultsArray =
          edadesAdults === "0" || !edadesAdults
            ? []
            : edadesAdults?.split(",")?.map(Number);

        // Devolver el objeto con la estructura requerida
        return {
          adults: parseInt(adultos, 10),
          minors: parseInt(menores, 10),
          agesAdults: edadesAdultsArray,
          ages: edadesArray,
        };
      });

    setPersons(PersonasFormatted);
    setTotalPersons(personas);
    setTotalPax(totalPersonas);

    // Construir el objeto final
    const request = {
      destino: {
        tipo,
        id,
      },
      fechas: {
        checkin,
        checkout,
      },
      personas,
    };

    setParamsUrl(request);

    return request;
  };

  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, []);

  useEffect(() => {
    requestData = construirRequest(); // Esto solo se ejecuta cuando `location.search` cambia
  }, [location?.search]);

  useEffect(() => {
    // Obtener la URL actual
    const queryParams = parseQueryParams(location?.search);

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = queryParams?.in;
    const checkOutDate = queryParams?.out;

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const nights = timeDifference / (1000 * 3600 * 24);

      setTotalNights(nights);
    }
  }, []);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("experiencias");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);
  const fetchFilter = async () => {
    const request = {
      idDestino: queryParams?.id,
    };
    try {
      const response = await getActividadesFilters(request);

      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };
  // Llamada combinada para hoteles y tarifas
  useEffect(() => {
    let isMounted = true; // Control de limpieza

    const fetchData = async () => {
      setLoading(true);

      try {
        // Paso 1: Cargar y mostrar `ActData`
        const ActData = await fetchActs();
        if (isMounted) {
          setFilteredActs(ActData); // Mostrar datos iniciales
          setLoading(false);
          setNameDestination(ActData?.[0]?.country?.destinations?.[0]?.name);
        }
        // Paso 2: Cargar y combinar `ratesData` y `ActData`
        const [filtersData] = await Promise?.all([
          fetchFilter(),
          // fetchRates(),
        ]);

        /* if (isMounted) {
           if (ratesData.length > 0) {
             setNameDestination(ratesData[0]);
           }
        } */
        const filtered = ActData?.filter(
          (a) => a?.country?.destinations?.[0]?.code === queryParams?.id
        );

        const result = [];
        const count = Math?.min(10, filtered?.length);

        // Copia temporal para no modificar el array original
        const temp = [...filtered];

        for (let i = 0; i < count; i++) {
          const randomIndex = Math?.floor(Math.random() * temp?.length);
          result.push(temp[randomIndex]);
          temp.splice(randomIndex, 1); // Eliminar para no repetir
        }

        setRandomActivities(result);
        const combinedActs = ActData;

        setFilteredActs(ActData); // Actualizar con datos combinados
        setActs(combinedActs);
        setFilters(filtersData);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) console.error("Failed to load data. Please try again.");
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Limpiar al desmontar
    };
  }, [location.search]);

  // Función para cargar los hoteles
  const fetchActs = async () => {
    const objDestino = requestData;
    try {
      const response = await getActividades(objDestino);

      return response?.activities;
    } catch (error) {
      console.error("Error fetching hotels:", error);
      return [];
    }
  };

  /**
   * Incrementa el número de resultados visibles en 10.
   * @returns {void}
   */
  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 10);
  };

  useEffect(() => {
    // Filtrar hoteles cuando selectedValues cambian
    filterActs();
  }, [selectedValues, acts]);
  // Función para manejar checkboxes
  const handleCheckboxChange = (sectionId, filterId, checked) => {
    setSelectedValues((prev) => {
      const section = prev[sectionId] || [];
      return {
        ...prev,
        [sectionId]: checked
          ? [...section, filterId]
          : section?.filter((id) => id !== filterId),
      };
    });
  };

  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, []);

  // Función para filtrar hoteles
  const filterActs = () => {
    const hasActiveFilters = Object?.values(selectedValues)?.some((value) => {
      if (value === null) return false;
      if (Array.isArray(value) && value?.length === 0) return false;
      return true;
    });

    if (!hasActiveFilters) {
      setFilteredActs(acts);
      return;
    }

    const filtered = acts?.filter((act) => {
      let matches = true;
      const categorias = act?.content?.segmentationGroups?.filter(
        (nameSeg) => nameSeg?.name === "Categorías"
      )?.[0]?.segments;
      const duracion = act?.content?.segmentationGroups?.filter(
        (nameSeg) => nameSeg?.name === "Franja horaria"
      )?.[0]?.segments;
      const recomendadoPara = act?.content?.segmentationGroups?.filter(
        (nameSeg) => nameSeg?.name === "Actividad recomendada para"
      )?.[0]?.segments;
      const servicios = act?.content?.segmentationGroups?.filter(
        (nameSeg) => nameSeg?.name === "Servicios"
      )?.[0]?.segments;
      if (
        selectedValues?.categorias &&
        selectedValues?.categorias?.length > 0
      ) {
        const segmentosSeleccionados = selectedValues?.categorias?.map(Number); // Convertir a números

        matches =
          matches &&
          segmentosSeleccionados?.some((segmento) =>
            categorias?.find((seg) => seg?.code === segmento)
          );
      }

      if (selectedValues?.duracion && selectedValues?.duracion?.length > 0) {
        const segmentosSeleccionados = selectedValues?.duracion?.map(Number); // Convertir a números
        matches =
          matches &&
          segmentosSeleccionados?.some((segmento) =>
            duracion?.find((seg) => seg?.code === segmento)
          );
      }

      if (
        selectedValues?.recomendadoPara &&
        selectedValues?.recomendadoPara?.length > 0
      ) {
        const segmentosSeleccionados =
          selectedValues?.recomendadoPara?.map(Number); // Convertir a números

        matches =
          matches &&
          segmentosSeleccionados?.some((segmento) =>
            recomendadoPara?.find((seg) => seg?.code === segmento)
          );
      }

      if (selectedValues?.servicios && selectedValues?.servicios?.length > 0) {
        const segmentosSeleccionados = selectedValues?.servicios?.map(Number); // Convertir a números

        matches =
          matches &&
          segmentosSeleccionados?.some((segmento) =>
            servicios?.find((seg) => seg?.code === segmento)
          );
      }

      return matches;
    });
    setFilteredActs(filtered);
  };
  const handleSelectActivity = (act) => {
    const activitiCode = act?.code;
    const checkIn = paramsUrl?.fechas?.checkin;
    const checkOut = paramsUrl?.fechas?.checkout;
    const storedArray = persons;
    const datosPrevios = JSON?.parse(
      sessionStorage?.getItem("datosReserva")
    ) || {
      hospedaje: [],
      actividades: [],
      traslados: [],
    };
    const paxParams = storedArray
      ?.map((act) => {
        const adultos = act?.adults;
        const edadesAdults =
          act?.agesAdults?.length > 0 ? act?.agesAdults?.join(",") : "0";
        const menores = act?.minors;
        const edades = act?.ages?.length > 0 ? act?.ages?.join(",") : "0";
        return `pax=${adultos}|${edadesAdults}|${menores}|${edades}`;
      })
      .join("&"); // Unir todos los parámetros de habitaciones con "&"
    let url = `/info-experiencia?idActividad=${activitiCode}&idDestino=${queryParams?.id}&in=${checkIn}&out=${checkOut}&${paxParams}`;
    const setDatos = {
      idPasarela: pdp?.nombre,
      hospedaje: datosPrevios?.hospedaje,
      actividades: [],
      traslados: datosPrevios?.traslados,
      lastUpdate: ahora?.toISOString(),
    };
    sessionStorage?.setItem("datosReserva", JSON?.stringify(setDatos));
    window?.dispatchEvent(new CustomEvent("cartUpdated"));
    // Usar React Router para redirigir
    window?.open(url, "_blank");
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseFilters = () => setShowFilters(false);
  const handleShowFilters = () => setShowFilters(true);

  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };
  const handleFilter = (id) => {
    if (id !== 0) {
      // Filtrar los datos que coincidan con el ID
      const filtered = ResultHotel?.filter((item) => item?.id === id);
      setFilteredData(filtered);
    } else {
      // Mostrar todos los datos originales
      setFilteredData(ResultHotel);
    }
  };
  console.log(filteredActs);
  console.log(acts);
  return (
    <div className="experiencias-resultado">
      {loading && <Loader />}
      <div className="results container py-2">
        <Row>
          <Col lg={3} md={5} sm={12}>
            {/* <h5
                className="text-purple"
                style={{ fontSize: "15px", marginLeft: "15px" }}
                >
                Modifica tu Búsqueda
                </h5> */}
            <div className={"modify-search"}>
              <div className="d-none d-md-block">
                <SearchEngine
                  isSeccionHome={false}
                  isResultsServices={true}
                  alojamientos={false}
                  isModify={true}
                  isHotel={false}
                  actividades={true}
                  isExperiencias={true}
                  isModifyHotel={false}
                  isInfoHotel={false}
                  totalPersons={totalPersons}
                  arrayPersons={persons}
                  destination={nameDestination}
                  idLocation={queryParams?.id}
                  selectedDates={selectedDates}
                  totalRooms={[]}
                  arrayRooms={[]}
                />
              </div>
              <Col lg={12} md={12} xs={12} className="">
                <Button
                  className={[
                    "d-md-none",
                    "d-block",
                    "w-100",
                    "btn-purple",
                    "mt-3",
                    "mb-4",
                    "rounded-4",
                  ]}
                  onClick={handleShow}
                  style={{ backgroundColor: "#305282", border: "none" }}
                >
                  Modificar Búsqueda
                </Button>

                <Modal show={show} onHide={handleClose}>
                  <Modal.Body>
                    <SearchEngine
                      isSeccionHome={false}
                      isResultsServices={true}
                      alojamientos={false}
                      isModify={true}
                      isHotel={false}
                      actividades={true}
                      isExperiencias={true}
                      isModifyHotel={false}
                      isInfoHotel={false}
                      totalPersons={totalPersons}
                      arrayPersons={persons}
                      destination={nameDestination}
                      idLocation={queryParams?.id}
                      selectedDates={selectedDates}
                      totalRooms={[]}
                      arrayRooms={[]}
                    />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Col>
              <Col lg={12} md={12} xs={12} className="">
                <div
                  className="d-md-block d-none p-4 shadow mt-3 rounded-4"
                  id="filters-tours"
                >
                  <p
                    style={{
                      fontSize: "20px",
                      borderBottom: "2px solid #969696",
                    }}
                  >
                    Filtrar por:
                  </p>
                  {filters && (
                    <Accordion
                      // className={styles.SearchEngineDesktop}
                      defaultValue="0"
                    >
                      <Accordion.Item
                        eventKey="0"
                        className="border-bottom border-2"
                      >
                        <Accordion.Header>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="m-0">Categorías</p> <IoIosArrowDown />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {filters?.categorias?.map((filter, index) => (
                            <Form key={(index + 1)?.toString()}>
                              <Form.Group className="mb-2">
                                {
                                  <Form.Check
                                    type="checkbox"
                                    label={filter?.nombre}
                                    id={`${filter?.codigo_categoria}`}
                                    checked={
                                      selectedValues?.categorias?.includes(
                                        filter?.codigo_categoria
                                      ) || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        "categorias",
                                        filter?.codigo_categoria,
                                        e?.target?.checked
                                      )
                                    }
                                  />
                                }
                              </Form.Group>
                            </Form>
                          ))}
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="1"
                        // key={filter.code}
                        className="border-bottom border-2"
                      >
                        <Accordion.Header>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="m-0">Actividad recomendada para</p>{" "}
                            <IoIosArrowDown />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {filters?.recomendadoPara?.map((filter, index) => (
                            <Form key={(index + 1)?.toString()}>
                              <Form.Group className="mb-2">
                                {
                                  <Form.Check
                                    type="checkbox"
                                    label={filter?.nombre}
                                    id={`${filter?.codigo_recomendado_para}`}
                                    checked={
                                      selectedValues?.recomendadoPara?.includes(
                                        filter?.codigo_recomendado_para
                                      ) || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        "recomendadoPara",
                                        filter?.codigo_recomendado_para,
                                        e?.target?.checked
                                      )
                                    }
                                  />
                                }
                              </Form.Group>
                            </Form>
                          ))}
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="2"
                        // key={filter.code}
                        className="border-bottom border-2"
                      >
                        <Accordion.Header>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="m-0">Servicios</p> <IoIosArrowDown />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {filters?.servicios?.map((filter, index) => (
                            <Form key={(index + 1)?.toString()}>
                              <Form.Group className="mb-2">
                                {
                                  <Form.Check
                                    type="checkbox"
                                    label={filter?.nombre}
                                    id={`${filter?.codigo_servicio}`}
                                    checked={
                                      selectedValues?.servicios?.includes(
                                        filter?.codigo_servicio
                                      ) || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        "servicios",
                                        filter?.codigo_servicio,
                                        e?.target?.checked
                                      )
                                    }
                                  />
                                }
                              </Form.Group>
                            </Form>
                          ))}
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item
                        eventKey="3"
                        // key={filter.code}
                        className="mb-2 border-bottom border-2"
                      >
                        <Accordion.Header>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="m-0">Duración</p> <IoIosArrowDown />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {filters?.duracion?.map((filter, index) => (
                            <Form key={(index + 1)?.toString()}>
                              <Form.Group className="mb-2">
                                {
                                  <Form.Check
                                    type="checkbox"
                                    label={filter?.nombre}
                                    id={`${filter?.codigo_duracion}`}
                                    checked={
                                      selectedValues?.duracion?.includes(
                                        filter?.codigo_duracion
                                      ) || false
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        "duracion",
                                        filter?.codigo_duracion,
                                        e?.target?.checked
                                      )
                                    }
                                  />
                                }
                              </Form.Group>
                            </Form>
                          ))}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  )}
                </div>
                <Button
                  className={[
                    "d-md-none",
                    "d-block",
                    "w-100",
                    "btn-purple",
                    "mt-3",
                    "mb-4",
                    "rounded-4",
                  ]}
                  style={{ backgroundColor: "#305282", border: "none" }}
                  onClick={handleShowFilters}
                >
                  Filtros de búsqueda
                </Button>

                <Modal show={showFilters} onHide={handleCloseFilters}>
                  <Modal.Body>
                    {filters && (
                      <Accordion
                        // className={styles.SearchEngineMobile}
                        defaultValue="0"
                      >
                        <Accordion.Item eventKey="0" className="mb-2">
                          <Accordion.Header className="border-bottom border-2">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">Categorías</p>{" "}
                              <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {filters?.categorias?.map((filter, index) => (
                              <Form key={(index + 1)?.toString()}>
                                <Form.Group className="mb-2">
                                  {
                                    <Form.Check
                                      type="checkbox"
                                      label={filter?.nombre}
                                      id={`${filter?.codigo_categoria}`}
                                      checked={
                                        selectedValues?.categorias?.includes(
                                          filter?.codigo_categoria
                                        ) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          "categorias",
                                          filter?.codigo_categoria,
                                          e?.target?.checked
                                        )
                                      }
                                    />
                                  }
                                </Form.Group>
                              </Form>
                            ))}
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item
                          eventKey="1"
                          // key={filter.code}
                          className="mb-2"
                        >
                          <Accordion.Header className="border-bottom border-2">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">Actividad recomendada para</p>{" "}
                              <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {filters?.recomendadoPara?.map((filter, index) => (
                              <Form key={(index + 1)?.toString()}>
                                <Form.Group className="mb-2">
                                  {
                                    <Form.Check
                                      type="checkbox"
                                      label={filter?.nombre}
                                      id={`${filter?.codigo_recomendado_para}`}
                                      checked={
                                        selectedValues?.recomendadoPara?.includes(
                                          filter?.codigo_recomendado_para
                                        ) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          "recomendadoPara",
                                          filter?.codigo_recomendado_para,
                                          e?.target?.checked
                                        )
                                      }
                                    />
                                  }
                                </Form.Group>
                              </Form>
                            ))}
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item
                          eventKey="2"
                          // key={filter.code}
                          className="mb-2"
                        >
                          <Accordion.Header className="border-bottom border-2">
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">Servicios</p>{" "}
                              <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {filters?.servicios?.map((filter, index) => (
                              <Form key={(index + 1)?.toString()}>
                                <Form.Group className="mb-2">
                                  {
                                    <Form.Check
                                      type="checkbox"
                                      label={filter?.nombre}
                                      id={`${filter?.codigo_servicio}`}
                                      checked={
                                        selectedValues?.servicios?.includes(
                                          filter?.codigo_servicio
                                        ) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          "servicios",
                                          filter?.codigo_servicio,
                                          e?.target?.checked
                                        )
                                      }
                                    />
                                  }
                                </Form.Group>
                              </Form>
                            ))}
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item
                          eventKey="3"
                          // key={filter.code}
                          className="mb-2"
                        >
                          <Accordion.Header className="border-bottom border-2">
                            {" "}
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <p className="m-0">Duración</p> <IoIosArrowDown />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            {filters?.duracion?.map((filter, index) => (
                              <Form key={(index + 1)?.toString()}>
                                <Form.Group className="mb-2">
                                  {
                                    <Form.Check
                                      type="checkbox"
                                      label={filter?.nombre}
                                      id={`${filter?.codigo_duracion}`}
                                      checked={
                                        selectedValues?.duracion?.includes(
                                          filter?.codigo_duracion
                                        ) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          "duracion",
                                          filter?.codigo_duracion,
                                          e?.target?.checked
                                        )
                                      }
                                    />
                                  }
                                </Form.Group>
                              </Form>
                            ))}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseFilters}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Col>
            </div>

            <div className="py-4 d-md-flex d-none">
              <div className="position-relative">
                <img src={bannerLuckyDay} className="w-100" alt="" />
                <Link
                  to={"/circuitos"}
                  onClick={() => {
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  <Button
                    type="button"
                    className="btn-blue btn-float-right-hotel rounded-5 lucky-day-hotel"
                  >
                    Hoy es mi día de suerte
                  </Button>
                </Link>
              </div>
            </div>
          </Col>
          {!loading ? (
            <Col lg={8} md={7} sm={12}>
              <>
                {filteredActs?.length === 0 && (
                  <Col xl={7} lg={6} md={12}>
                    <div className="text-center mt-5">
                      <h1>0 Tours disponibles con sus filtros de busqueda</h1>
                      <br />
                      <h2 className="text-muted">
                        No hay Tours disponibles con estos filtros
                      </h2>
                    </div>
                  </Col>
                )}
              </>

              {filteredActs?.length > 0 ? (
                <>
                  <h3 className="mb-0 p-2 text-lg-start text-center">
                    {filteredActs?.length} Tours disponibles con sus filtros de
                    busqueda
                  </h3>
                  {filteredActs
                    ?.slice(0, visibleCount)
                    ?.map((dataAct, index) => {
                      return (
                        <div
                          key={index + 1}
                          className="d-flex justify-content-center"
                        >
                          <div className="cards-hotels mt-3">
                            <Card
                              className="shadow rounded-5 p-3 border-0 hotelCard"
                              onClick={() => handleSelectActivity(dataAct)}
                            >
                              <Row>
                                <Col lg={5} md={12} sm={12}>
                                  <img
                                    src={
                                      dataAct?.content?.media?.images?.[0]
                                        ?.urls?.[1]?.resource
                                        ? dataAct?.content?.media?.images?.[0]
                                            ?.urls?.[1]?.resource
                                        : imgPreview
                                    }
                                    alt=""
                                    style={{
                                      width: "100%",
                                      height: "250px",
                                      borderRadius: "15px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Col>
                                <Col
                                  lg={4}
                                  md={12}
                                  sm={12}
                                  style={{
                                    padding: "20px 20px 10px 20px",
                                    display: "grid",
                                  }}
                                >
                                  <div className="name-hotel d-flex justify-content-between">
                                    <div>
                                      <h4
                                        className="title-hotel"
                                        style={{ fontSize: "20px" }}
                                      >
                                        {dataAct?.name}
                                      </h4>
                                      {dataAct?.country?.destinations?.map(
                                        (destination, index) => (
                                          <p
                                            key={index + 1}
                                            className="text-muted m-0"
                                          >
                                            {destination?.name}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  </div>
                                  <p
                                    className="text-secondary"
                                    style={{
                                      overflowY: "auto",
                                      height: "77px",
                                      maxHeight: "77px",
                                      margin: "0",
                                      textAlign: "justify",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: dataAct?.content?.description,
                                    }}
                                  />
                                </Col>
                                <Col
                                  className="d-flex flex-column"
                                  lg={3}
                                  md={12}
                                  sm={12}
                                  style={{
                                    padding: "20px 20px 10px 20px",
                                    textAlign: "end",
                                  }}
                                >
                                  <span className="text-secondary">
                                    Duración de{" "}
                                    {dataAct?.modalities?.[0]?.duration?.value}{" "}
                                    Día(s)
                                  </span>
                                  {dataAct?.amountsFrom?.map((amount) => (
                                    <>
                                      {amount?.paxType === "ADULT" && (
                                        <span
                                          key={index}
                                          className="text-blue"
                                          style={{
                                            fontSize: "25px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {comisionUsuario?.actividades && (
                                            <>
                                              <span
                                                style={{
                                                  fontSize: "17px",
                                                  color: "#8e8e8e",
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                {Currency(
                                                  totalPrices(
                                                    amount?.amount,
                                                    markup,
                                                    totalNights
                                                  )[1]
                                                )}{" "}
                                                MXN
                                              </span>
                                              <br />
                                            </>
                                          )}
                                          {Currency(
                                            totalPrices(
                                              amount?.amount,
                                              markup,
                                              totalNights,
                                              comisionUsuario?.actividades
                                            )[1]
                                          )}
                                          <span style={{ fontSize: "17px" }}>
                                            {" "}
                                            MXN
                                          </span>
                                        </span>
                                      )}
                                    </>
                                  ))}
                                  <p className={"text-secondary"}>
                                    Impuestos incluidos*
                                  </p>
                                </Col>
                              </Row>
                            </Card>
                          </div>
                        </div>
                      );
                    })}
                </>
              ) : (
                <>
                  <>
                    <div className="d-flex justify-content-center">
                      {loading ? (
                        ""
                      ) : (
                        <h1 className="text-center mt-4 pb-5">
                          No se encontraron actividades con estos filtros
                        </h1>
                      )}
                    </div>
                  </>
                </>
              )}
              {visibleCount < filteredActs?.length && (
                <div className="d-flex justify-content-center w-100">
                  <Button
                    onClick={handleShowMore}
                    className={`btn-blue mt-3`}
                    style={{ width: "15rem" }}
                  >
                    Ver más
                  </Button>
                </div>
              )}
            </Col>
          ) : (
            <Col lg={8} md={7} sm={12}>
              <Skeleton width={300} height={30} count={1} />
            </Col>
          )}
          <div className="py-4 d-md-none d-flex justify-content-center">
            <div className="position-relative">
              <img src={bannerLuckyDay} className="w-100" alt="" />
              <Link
                to={"/circuitos"}
                onClick={() => {
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
                }}
              >
                <Button
                  type="button"
                  className="btn-blue btn-float-right-hotel rounded-5 lucky-day-hotel"
                >
                  <FaStar /> Hoy es mi día de suerte
                </Button>
              </Link>
            </div>
          </div>
        </Row>
      </div>
      {/* <div className="section-about-reservation ps-lg-5 pe-0 m-xl-5">
        <div className="section-cards-hotel container p-4 pt-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
              ¿Necesitas alojamiento para tu estancia?
            </h3>
            <h5
              className="title-home d-lg-flex d-none text-start"
              style={{ fontSize: "30px", width: "30rem" }}
            >
              Encuentra un hospedaje en la misma ubicación de tu experiencia y
              disfruta de tu viaje.
            </h5>
          </div>
          <Row className="cards-sliders d-flex justify-content-center">
            <Slider {...settingsInfoHotel} className="hotels-slider">
              {destinies.map((dataHotel, index) => {
                return (
                  <div
                    className="d-flex justify-content-center"
                    key={index + 1}
                  >
                    <CardCarrousel
                      seccion={"experenciasResult"}
                      datahotel={dataHotel}
                    />
                  </div>
                );
              })}
            </Slider>
          </Row>
        </div>
      </div> */}
      <div className="section-about-reservation container py-5">
        <SectionAdvise />
      </div>
    </div>
  );
};
